(function () {
  var info = document.querySelector('.product__info-container');
  if (!info) return;

  // Halloween pill just above the product title.
  var pill = document.getElementById('n-pdp-pill');
  var title = info.querySelector('.product__title');
  if (pill && title && !info.querySelector('.n-pdp-pill')) {
    title.insertAdjacentElement('beforebegin', pill.content.firstElementChild.cloneNode(true));
  }

  // Benefit lines (text blocks with an icon) become one tinted box with checkmarks.
  var bullets = Array.prototype.filter.call(
    info.querySelectorAll(':scope > .product__text-container'),
    function (el) { return el.querySelector('img, .material-icon, svg'); }
  );
  if (bullets.length > 1) {
    var box = document.createElement('div');
    box.className = 'n-benefits';
    bullets[0].insertAdjacentElement('beforebegin', box);
    bullets.forEach(function (el) { el.classList.add('n-benefit'); box.appendChild(el); });
  }

  // Market trust row right under the add-to-cart / payment icons.
  // The template's own icon row says the same thing, so it is hidden.
  var tpl = document.getElementById('n-pdp-trust');
  if (tpl && !info.querySelector('.n-trust')) {
    var anchor = info.querySelector(':scope > .payment-badges-block') ||
      (info.querySelector('.product-form') && info.querySelector('.product-form').closest('.product__info-container > *'));
    if (anchor) anchor.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    info.querySelectorAll(':scope > .icon-with-text').forEach(function (el) { el.classList.add('n-hidden'); });
  }

  // Story sections directly after the main product section.
  var story = document.getElementById('n-story');
  var mainSection = info.closest('.shopify-section');
  if (story && mainSection) mainSection.insertAdjacentElement('afterend', story);
  // One comparison per page: when ours is there, the template's own table steps aside.
  if (story && story.querySelector('.n-compare')) {
    document.querySelectorAll('.shopify-section[id*="comparison_table"], .shopify-section[id*="ss_comparison_table"]').forEach(function (s) { s.classList.add('n-hidden'); });
  }

  document.querySelectorAll('[data-n-scroll-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = info.querySelector('variant-selects, .kaching-bundles, .product-form') || info;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
